/** Préférence UI : lier image PNG et modèle 3D du même basename. */
export const CAR_MEDIA_LINK_STORAGE_KEY = 'multirx-car-link-image-model3d';

const LIBRARY_BASE = '/assets/cars/library';
const MODELS_3D_BASE = '/assets/cars/models3d';

/** Basename sans extension (`car_trello_005.png` → `car_trello_005`). */
export function assetBasename(path: string | null | undefined): string | null {
  if (!path?.trim()) return null;
  const file = path.trim().split('/').pop() ?? '';
  const base = file.replace(/\.[^./]+$/, '').trim();
  return base || null;
}

/** `true` si image et modèle partagent le même basename. */
export function carMediaBasenamesMatch(
  imagePath: string | null | undefined,
  model3dPath: string | null | undefined
): boolean {
  const a = assetBasename(imagePath);
  const b = assetBasename(model3dPath);
  return a != null && b != null && a === b;
}

/**
 * Chemin modèle 3D pairé à un visuel bibliothèque
 * (`…/library/car_trello_005.png` → `…/models3d/car_trello_005.glb`).
 */
export function pairedCarModel3dPath(imagePath: string): string | null {
  const base = assetBasename(imagePath);
  if (!base) return null;
  return `${MODELS_3D_BASE}/${base}.glb`;
}

/**
 * Chemin image bibliothèque pairé à un modèle 3D
 * (`…/models3d/car_trello_005.glb` → `…/library/car_trello_005.png`).
 */
export function pairedCarImagePath(model3dPath: string): string | null {
  const base = assetBasename(model3dPath);
  if (!base) return null;
  return `${LIBRARY_BASE}/${base}.png`;
}

export function readCarMediaLinkPreference(defaultValue = true): boolean {
  try {
    const raw = sessionStorage.getItem(CAR_MEDIA_LINK_STORAGE_KEY);
    if (raw === null) return defaultValue;
    return raw === '1';
  } catch {
    return defaultValue;
  }
}

export function writeCarMediaLinkPreference(linked: boolean): void {
  try {
    sessionStorage.setItem(CAR_MEDIA_LINK_STORAGE_KEY, linked ? '1' : '0');
  } catch {
    /* ignore quota / private mode */
  }
}
